<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M10.5 0.34375C4.89086 0.34375 0.34375 4.89086 0.34375 10.5C0.34375 16.1091 4.89086 20.6562 10.5 20.6562C16.1091 20.6562 20.6562 16.1091 20.6562 10.5C20.6562 4.89086 16.1091 0.34375 10.5 0.34375ZM8.70868 7.60382C8.40358 7.29873 7.90892 7.29873 7.60382 7.60382C7.29873 7.90892 7.29873 8.40358 7.60382 8.70868L9.39515 10.5L7.60382 12.2913C7.29873 12.5964 7.29873 13.0911 7.60382 13.3962C7.90892 13.7013 8.40358 13.7013 8.70868 13.3962L10.5 11.6049L12.2913 13.3962C12.5964 13.7013 13.0911 13.7013 13.3962 13.3962C13.7013 13.0911 13.7013 12.5964 13.3962 12.2913L11.6049 10.5L13.3962 8.70868C13.7013 8.40358 13.7013 7.90892 13.3962 7.60382C13.0911 7.29873 12.5964 7.29873 12.2913 7.60382L10.5 9.39515L8.70868 7.60382Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgCloseFill',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>